
export class PlayerProfileVO {
    public bonus: number = 0;
    public giftsSend: number = NaN;
    public giftsReceived: number = NaN;
    public fInvited: number = 0;
    public gamesPlayed: number = 0;
    public wins: number = NaN;
    public pTime: number = NaN;
    public pTimeSession: number = NaN;
    public bestHand: number = 0;
    public winLoss: number = NaN;
    public winningStreak: number = 0;
    public loosingStreak: number = 0;
    public tPlayed: number = 0;
    public tWon: number = 0;
    public tFinalTable: number = 0;
    public tWonChips: number = NaN;
    public tWonGold: number = NaN;

    // Booster
    public booster: any[];

    //Erweiterte Stats
    public playerStats: any[];
}
